export default __webpack_public_path__ + "static/media/magnifying_glass_animation.592c1799.svg";